import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ContentWarning from './ContentWarning'
import styled from 'styled-components'
import { P2, Caption1 } from '../styled/typography/typography'

const Caption1CW = styled(Caption1)`
  margin-bottom: 5px;
`

export default class ContentWarnings extends Component {
  render () {
    const { contentWarnings, displayListWithText } = this.props
    return (
      <div>
        {displayListWithText ? (
          <ul className='content-warning-list pad'>
            {contentWarnings.map((warningObject, key) => {
              let warning = Object.values(warningObject)[0]
              return (
                <li
                  key={key}
                  className='content-warning-list-item'>
                  <ContentWarning
                    key={key}
                    text={warning.text}
                    abbrev={warning.abbrev} />
                  <P2 className='content-warning-label'>
                    {warning.text}
                  </P2>
                </li>
              )
            })}
          </ul>
        ) : (
          <div className='content-warning-wrapper'>
            <Caption1CW>Just For Mentors: </Caption1CW>
            {contentWarnings.map((warning, key) => {
              return (
                <ContentWarning
                  key={key}
                  text={warning.text}
                  abbrev={warning.abbrev} />
              )
            })}
          </div>
        )}
      </div>
    )
  }
}

ContentWarnings.propTypes = {
  contentWarnings: PropTypes.array,
  displayListWithText: PropTypes.bool
}
